import { Component, Injector } from '@angular/core';
import {
  LoaderService,
  MessageService,
  ValidationResultService,
} from '@shared';
import { AlertsService, CategoryService } from '@shared-data';
import { RestaurantItemService } from '../../services';
import { GridRowSubstitutionPricingChangeset } from '../../models';
import { pricingProductTypes } from '../../constants';
import { ActivatedRoute } from '@angular/router';
import { BasePricingChangesetComponent } from '../base-pricing-changeset/base-pricing-changeset.component';

@Component({
  selector: 'app-substitution-changeset',
  templateUrl: './substitution-changeset.component.html',
  styleUrl: './substitution-changeset.component.scss',
})
export class SubstitutionChangesetComponent extends BasePricingChangesetComponent {
  productTypes = pricingProductTypes;

  currentComponentId: number | null = null;

  constructor(
    validationErrorService: ValidationResultService,
    messageService: MessageService,
    loaderService: LoaderService,
    categoryService: CategoryService,
    restaurantItemsService: RestaurantItemService,
    activatedRoute: ActivatedRoute,
    injector: Injector,
  ) {
    super(
      validationErrorService,
      messageService,
      loaderService,
      restaurantItemsService,
      categoryService,
      activatedRoute,
      injector,
      GridRowSubstitutionPricingChangeset,
    );
  }
}
